import { type DroneLive, useDronesStore } from '@/lib/store/drones';
import { useUiStore } from '@/lib/store/ui';

/**
 * Fleet passing the drone category filter (FleetList's `drone-filter-row`:
 * All / Internal / Partner / Network ID).
 *
 * Every map layer that draws per-drone geometry goes through this so the
 * filter row moves the MAP as well as the list — otherwise "Internal" trims
 * the list while the map keeps painting every partner / Network ID aircraft.
 *
 * The filter row only exists in drones-ctx, so any other context sees the
 * whole fleet rather than a filter the user can't see or undo from there.
 */
export function visibleFleet(): DroneLive[] {
  const all = Object.values(useDronesStore.getState().byId);
  const ui = useUiStore.getState();
  if (ui.activeContext !== 'drones' || ui.droneCategory === 'all') return all;
  return all.filter((d) => d.origin === ui.droneCategory);
}

/** Subscription key for layers that must re-sync when the filter changes. */
export const droneFilterKey = (s: {
  activeContext: string;
  droneCategory: string;
}): string => `${s.activeContext}|${s.droneCategory}`;
